import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = { class: "font-bold mb-2 text-center" }
const _hoisted_3 = { class: "space-y-4" }
const _hoisted_4 = {
  key: 0,
  class: "text-red-500 mt-4 -mb-16"
}
const _hoisted_5 = { class: "mt-20" }

import { // auth
		Auth
	} from '@/api/Auth'
	
	import { // components
		DialogDescription
	} from '@headlessui/vue'

	import { // languages
		useI18n
	} from 'vue-i18n'
	
	import { // router
		useRouter
	} from 'vue-router'

	import { // stores
		store as _userStore
	} from '@/store/user'
	
	import { // types
		Notification
	} from '@/types'
	
	import { // vue
		ref
	} from 'vue'

	
	const __default__ = { name: "ChangeEmailForm" } 	// name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['closeEmailModal'],
  setup(__props, { emit: __emit }) {

	const userStore = _userStore()
	const router = useRouter()

	const {t} = useI18n()
	
	let email = userStore.user.email
	
	const currentPassword = ref("")
	const newEmail = ref("")
	const confirmNewEmail = ref("")
	const error = ref(false)
	const errorMsg = ref('')
	const formLoading = ref(false)
	const inputPassword = ref<null | {valid: Boolean}>(null)
	const inputNewEmail = ref<null | {valid: Boolean}>(null)
	const inputConfirmNewEmail = ref<null | {valid: Boolean}>(null)
	const emailConfirmMessage = ref(t('changeEmail.newEmailValidation'))
	const emailValidateMessage = ref(t('changeEmail.newEmailValidation'))

	const emit = __emit

	async function updateEmail() {
		formLoading.value = true
		let formError = false
		
		if (currentPassword.value == "") {
			document.getElementById('currentPassword')?.focus()
			if(inputPassword.value)inputPassword.value.valid = false
			formError = true
		}
		if (newEmail.value == "") {
			document.getElementById('newEmail')?.focus()
			emailValidateMessage.value = t('changeEmail.newEmailValidation')
			if(inputNewEmail.value)inputNewEmail.value.valid = false
			formError = true
		}
		if (newEmail.value == email) {
			document.getElementById('newEmail')?.focus()
			emailValidateMessage.value = t('changeEmail.differentEmailError')
			if(inputNewEmail.value)inputNewEmail.value.valid = false
			formError = true
		}
		if (confirmNewEmail.value == "") {
			document.getElementById('email')?.focus()
			if(inputConfirmNewEmail.value)inputConfirmNewEmail.value.valid = false
			formError = true
		}
		if (newEmail.value != confirmNewEmail.value) {
			document.getElementById('confirmNewEmail')?.focus()
			emailConfirmMessage.value = t('changeEmail.emailMismatch')
			if(inputConfirmNewEmail.value)inputConfirmNewEmail.value.valid = false
			formError = true
		}	
		
		if(formError) {
			formLoading.value = false
			return
		}

		try {
			error.value = false
			errorMsg.value = ''

			let response = await Auth.changeEmail(email, newEmail.value, currentPassword.value)

			if(!response.success) {
				error.value = true
				errorMsg.value = response?.messages?.[0]?.message ?? t('changeEmail.generalError')
				throw errorMsg.value
			}

			const notification: Notification = {
				title: t('placeholders.success'),
				subtitle: t('changeEmail.emailUpdated'),
				icon: 0
			}

			emit('closeEmailModal', notification)
			userStore.user.email = newEmail.value
			email = newEmail.value
			currentPassword.value = ""
			newEmail.value = ""
			confirmNewEmail.value = ""
			router.push({name: 'Account'})
		} 
		catch(e) {
			console.log(e)
		}
		finally {
			formLoading.value = false
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_input = _resolveComponent("tw-input")!
  const _component_tw_button = _resolveComponent("tw-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DialogDescription), {
      as: "h3",
      class: "mb-6"
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)('changeEmail.descriptionStub')), 1),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(userStore)?.user?.email), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('changeEmail.description')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("form", {
      onSubmit: _withModifiers(updateEmail, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_tw_input, {
          modelValue: currentPassword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPassword).value = $event)),
          id: "currentPassword",
          ref_key: "inputPassword",
          ref: inputPassword,
          required: true,
          type: "password",
          label: _unref(t)('changeEmail.currentPass'),
          validation: _unref(t)('updatePassword.currentPasswordValidation'),
          class: "text-md"
        }, null, 8, ["modelValue", "label", "validation"]),
        _createVNode(_component_tw_input, {
          modelValue: newEmail.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newEmail).value = $event)),
          id: "newEmail",
          ref_key: "inputNewEmail",
          ref: inputNewEmail,
          required: true,
          type: "email",
          label: _unref(t)('changeEmail.newEmail'),
          validation: emailValidateMessage.value,
          class: "text-md"
        }, null, 8, ["modelValue", "label", "validation"]),
        _createVNode(_component_tw_input, {
          modelValue: confirmNewEmail.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((confirmNewEmail).value = $event)),
          id: "confirmNewEmail",
          ref_key: "inputConfirmNewEmail",
          ref: inputConfirmNewEmail,
          required: true,
          type: "email",
          label: _unref(t)('changeEmail.confirmEmail'),
          validation: emailConfirmMessage.value
        }, null, 8, ["modelValue", "label", "validation"])
      ]),
      (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(errorMsg.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_tw_button, {
          disabled: formLoading.value,
          loading: formLoading.value,
          type: "submit",
          class: "btn-base btn-brand w-full",
          onClick: updateEmail
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('changeEmail.title')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ], 32)
  ], 64))
}
}

})